import {Fragment, h} from 'preact';
import Button from '../form/Button';
import Dialog from '../media/Dialog';
import {useCallback, useState} from 'preact/hooks';
import InviteUserForm from './InviteUserForm';

interface Props {
  onSuccess?(): any;
}

export default function InviteUserButton({onSuccess}: Props) {
  const [showDialog, toggleDialog] = useState(false);

  const dialog = {
    show: toggleDialog.bind(null, true),
    hide: toggleDialog.bind(null, false)
  };

  const click = useCallback((event: MouseEvent) => {
    event.stopPropagation();
    dialog.show();
  }, [dialog]);

  return (
    <Fragment>
      <Button small={true} primary={true} onClick={click}>
        Invite Teammate
      </Button>
      <Dialog show={showDialog} onRequestClose={dialog.hide}>
        <InviteUserForm
          onCancel={dialog.hide}
          onSuccess={() => {
            dialog.hide();
            if (onSuccess) onSuccess();
          }}
        />
      </Dialog>
    </Fragment>
  )
}